export class ProtocolStepConfig{
	isArray?: boolean = false;
	isLastProtocolComponentBeforeResultHandling?: boolean = false;
	isLastStepOfArrayList? = false;
	labID?: string;
    plateID?: string;
    isStoragePlate?: boolean;
}